import services from "@src/Services";

export const getApiResponse = async (path: string) => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(`/${path}`);
    if (res.status === 200) return { data: res?.data.data, error: null };
    return {
      data: null,
      error: res?.data?.data.error || "Something went wrong!",
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      data: null,
      error: err?.error?.message || "Something went wrong!",
    };
  }
};
